import { scrollbarDataIdAttribute } from '@widgets/shared/const'

export class ScrollbarService {
  public getElement(id: string): HTMLElement | undefined {
    return document.querySelector<HTMLElement>(`[${scrollbarDataIdAttribute}="${id}"]`) || undefined
  }

  public scroll(id: string, options: ScrollToOptions = { top: 0, left: 0 }) {
    this.getElement(id)?.scroll(options)
  }

  public scrollToBottom(id: string, behavior?: ScrollBehavior) {
    const state = this.getState(id)
    if (!state) {
      return
    }
    this.scroll(id, { top: state.scrollHeight, behavior })
  }

  public scrollToElement(elementSelector: string, options?: ScrollIntoViewOptions) {
    document.querySelector<HTMLElement>(elementSelector)?.scrollIntoView(options)
  }

  public getState(id: string) {
    const element = this.getElement(id)
    if (!element) {
      return undefined
    }
    const scrollTop = Math.round(element.scrollTop)
    const scrollHeight = Math.round(element.scrollHeight)
    const clientHeight = Math.round(element.clientHeight)

    return {
      scrollTop,
      scrollBottom: scrollHeight - clientHeight - scrollTop,
      scrollHeight,
      clientHeight,
    }
  }

  public addScrollListener(id: string, callback: () => void) {
    const element = this.getElement(id)
    if (!element) {
      return
    }
    element.addEventListener('scroll', callback)
  }

  public removeScrollListener(id: string, callback: () => void) {
    const element = this.getElement(id)
    if (!element) {
      return
    }
    element.removeEventListener('scroll', callback)
  }
}

export default new ScrollbarService()
